import React from 'react'
import * as PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import Button from '@material-ui/core/Button'
// import Link from '@material-ui/core/Link'
import logoNextinit from 'img/nxt-mini-logo-65x45.png'
import styles from './View.Style'
import Image from '../../../../components/image/View'
import defaultAvatar from '../../../../img/default-photo.png'

const ChooseList = props => {
  const { classes, info, onClick } = props
  return (
    <div className={classes.content}>
      <div className={classes.choose}>
        <h1 className={classes.title}>
          Select a INNOVATE!
          <small>Please select the INNOVATE! you want to access</small>
        </h1>

        <ul className={classes.list}>
          {info.map(row => {
            const { avatarUrl, logoUrl, nextinitName, userName, domain } = row
            return (
              <li className={classes.listItem} key={nextinitName}>
                <Button className={classes.identityButton} onClick={() => onClick(domain)}>
                  <Image
                    alt="company logo"
                    className={classes.mediaLogo}
                    src={logoUrl}
                    defaultSrc={logoNextinit}
                  />

                  <div className={classes.mediaBody}>
                    <h2>{nextinitName}</h2>
                    <span>
                      Access as <b>{userName}</b>
                    </span>
                  </div>

                  <Image
                    alt="user"
                    className={classes.mediaPhoto}
                    src={avatarUrl}
                    defaultSrc={defaultAvatar}
                  />
                </Button>
              </li>
            )
          })}
        </ul>
        {/* <Button
          className={classes.button}
          color="primary"
          component={Link}
          to="/"
          variant="contained"
        >
          Or create a new Nextinit
        </Button> */}
      </div>
    </div>
  )
}

ChooseList.propTypes = {
  info: PropTypes.arrayOf(
    PropTypes.shape({
      avatarUrl: PropTypes.string,
      domain: PropTypes.string.isRequired,
      logoUrl: PropTypes.string,
      nextinitName: PropTypes.string,
      userName: PropTypes.string,
    }),
  ).isRequired,
  onClick: PropTypes.func.isRequired,
}

export default withStyles(styles)(ChooseList)
